import apiSlice from 'renderer/shared/state/apiSlice';
import {
  GetWebhookDetailRequest,
  GetWebhookDetailResponse,
  ListWebhooksRequest,
  ListWebhooksResponse,
  ListWebhooksResponseSchema,
  WebhookSchema,
} from '../schemas/webhook.schemas';

const extendedApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    listWebhooks: builder.query<ListWebhooksResponse, ListWebhooksRequest>({
      query: ({ page, limit }) => ({
        url: `/webhook?page=${page}&limit=${limit}`,
        method: 'GET',
      }),
      extraOptions: {
        responseSchema: ListWebhooksResponseSchema,
      },
    }),
    getWebhookDetails: builder.query<
      GetWebhookDetailResponse,
      GetWebhookDetailRequest
    >({
      query: (id) => ({
        url: `/webhook/${id}`,
        method: 'GET',
      }),
      extraOptions: {
        responseSchema: WebhookSchema,
      },
    }),
  }),
});

export const { useListWebhooksQuery, useGetWebhookDetailsQuery } = extendedApi;
